import React, { useState, useContext } from "react";
import { useTranslation } from "react-i18next";
import { AuthContext } from "../contexts/AuthContext";
import axios from "axios";
import { motion } from "framer-motion";
import { FaUser, FaBlog } from "react-icons/fa";

const Profile = () => {
  const { t } = useTranslation();
  const { user, updateUserProfile } = useContext(AuthContext);
  const [name, setName] = useState(user?.displayName || "");
  const [photo, setPhoto] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleFileChange = (e) => {
    setPhoto(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      let photoURL = user?.photoURL;
      if (photo) {
        const formData = new FormData();
        formData.append("file", photo);
        formData.append("upload_preset", "ml_default");

        const response = await axios.post(
          "https://api.cloudinary.com/v1_1/dct6kmn1g/image/upload",
          formData
        );
        photoURL = response.data.secure_url;
      }
      await updateUserProfile(name, photoURL);
      alert(t("profile.update_success"));
    } catch (err) {
      setError(t("profile.update_error"));
    } finally {
      setLoading(false);
    }
  };

  if (!user) {
    return (
      <motion.div
        className="container mx-auto p-4 text-center"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        {t("signin.title")}
      </motion.div>
    );
  }

  return (
    <motion.div
      className="container mx-auto p-4"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <h1 className="text-3xl font-bold text-center primary-text mb-4">{t("profile.title")}</h1>
      <form onSubmit={handleSubmit} className="max-w-md mx-auto p-6 glass rounded-lg">
        {error && <p className="text-red-500 mb-4 text-center">{error}</p>}
        <div className="custom-input">
          <input
            type="text"
            id="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder=" "
            dir="auto"
          />
          <label htmlFor="name">{t("profile.name")}</label>
        </div>
        <div className="custom-input">
          <input
            type="email"
            id="email"
            value={user.email}
            disabled
            placeholder=" "
            dir="auto"
          />
          <label htmlFor="email">{t("profile.email")}</label>
        </div>
        <div className="custom-file-input">
          <input
            type="file"
            id="photo"
            onChange={handleFileChange}
            className="hidden"
          />
          <label htmlFor="photo" className="cursor-pointer primary-text">
            {photo ? photo.name : t("profile.photo")}
          </label>
        </div>
        <img
          src={user.photoURL || "https://images.unsplash.com/photo-1511367461989-f85a21fda167"}
          alt="Profile"
          className="w-24 h-24 rounded-full mb-4 mx-auto"
        />
        <button
          type="submit"
          className="w-full p-2 bg-transparent border border-blue-500 primary-text hover:bg-blue-500 hover:text-white rounded transition-all flex items-center justify-center"
          disabled={loading}
        >
          {loading ? <div className="loading-spinner mr-2"></div> : t("profile.update")}
        </button>
      </form>
      <motion.div
        className="mt-8 text-center"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.2 }}
      >
        <h2 className="text-2xl font-bold primary-text mb-4">{t("profile.services")}</h2>
        <ul className="space-y-2">
          <li className="flex items-center justify-center">
            <FaUser className="mr-2 primary-text" />
            <a href="https://brt.iburtum.xyz" className="primary-text hover:text-blue-700 transition-all">
              {t("profile.profiles")}
            </a>
          </li>
          <li className="flex items-center justify-center">
            <FaBlog className="mr-2 primary-text" />
            <a href="https://blog.iburtum.xyz" className="primary-text hover:text-blue-700 transition-all">
              {t("profile.blog")}
            </a>
          </li>
        </ul>
      </motion.div>
    </motion.div>
  );
};

export default Profile;